import { useEffect } from 'react';

import { useEcomStore } from '@/data';
import { useUpdateQueryParams } from '@/hooks';
import { CollectionQueryParams, EnumCustomerType } from '@/types';

const useDeepLinkCustomerType = ({
  customerType,
}: {
  customerType?: EnumCustomerType;
}) => {
  const [, setStoredState] = useEcomStore();
  const { updateQueryParams } = useUpdateQueryParams();

  useEffect(() => {
    if (!customerType) {
      return;
    }

    setStoredState({
      customer_type: customerType,
    });

    updateQueryParams(undefined as unknown as CollectionQueryParams);
  }, [customerType]);
};

export { useDeepLinkCustomerType };
